<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="red darken-4">
            <v-toolbar-title>Login Form</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert type="error" v-if="errorMessage">{{ errorMessage }}.</v-alert>
            <v-form ref="form" v-model="valid">
              <v-text-field placeholder="Student number on your receipt" v-model="username" prepend-icon="mdi-account" name="username" label="Student Number" :rules="usernameRules" required/>
              <v-text-field placeholder="Last 6 digits of your phone number" v-model="password" prepend-icon="mdi-lock-question" name="password" label="Password" type="password" :rules="passwordRules" required/>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" @click="submit">
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Signin',
  props: {
    errorMessage: {
      type: String
    },
    paramUsername: {
      type: String
    },
    paramPass: {
      type: String
    }
  },
  data () {
    return {
      valid: false,
      username: '',
      password: '',
      usernameRules: [
        v => !!v || 'Student number is required',
        v => v && v.length >= 2 || 'Student number must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => v && v.length >= 6 || 'Password must be greater than 6 characters'
      ],
    }
  },
  mounted () {
    if (this.paramUsername || this.paramPass) {
      this.username = this.paramUsername;
      this.password = this.paramPass;
      this.$store.dispatch('userLogin', {
        username: this.username,
        password: this.password
      })
      this.$refs.form.validate();
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('userLogin', {
          username: this.username,
          password: this.password
        })
      }
    }
  }
}
</script>

<style scoped></style>
